import {useQuery, useMutation} from "@tanstack/react-query";
import axios from "axios";

export const useGetStats = () => {
	const url = process.env.REACT_APP_API_URL || 'https://api.concept.lawscore.com';

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(
			`${url}/api/stats`
		);
		const data: any = response.data;

		return data.data;
	};

	return useQuery<any[]>({
		queryKey: [
			"Stats"
		],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
	});
};

export const useGetFormulasQuery = () => {
	const url = process.env.REACT_APP_API_URL || 'https://api.concept.lawscore.com';

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(
			`${url}/api/formulas`
		);
		const data: any = response.data;

		return data.data;
	};

	return useQuery<any[]>({
		queryKey: [
			"Formulas"
		],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
	});
};

export const useGetNumericVariables = () => {
	const url = process.env.REACT_APP_API_URL || 'https://api.concept.lawscore.com';

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(
			`${url}/api/variables/numeric`
		);
		const data: any = response.data;

		return data.data;
	};

	return useQuery<any[]>({
		queryKey: [
			"Variables"
		],
		queryFn: queryFn,
		refetchOnWindowFocus: false,
	});
};

export const useChangeFormula = (
    onSuccess = (data: any, variables: any, context: any) => {},
    onFailure = (error: any, variables: any, context: any) => {},
    onMutate = (variables: any) => {}
) => {
	const url = process.env.REACT_APP_API_URL || 'https://api.concept.lawscore.com';

	const mutate = async (mutationData: any): Promise<any> => {
		const response = await axios.post(
			`${url}/api/formulas`,
            mutationData
		);
		const data: any = response.data;
		return data;
	};

	return useMutation({
        mutationFn: mutate,
        onSuccess: onSuccess,
        onError: onFailure,
        onMutate: onMutate
	});
};

export const useCreateFormula = (
    onSuccess = (data: any, variables: any, context: any) => {},
    onFailure = (error: any, variables: any, context: any) => {},
    onMutate = (variables: any) => {}
) => {
	const url = process.env.REACT_APP_API_URL || 'https://api.concept.lawscore.com';

	const mutate = async (mutationData: any): Promise<any> => {
		const response = await axios.put(
			`${url}/api/formulas`,
            mutationData
		);
		const data: any = response.data;
		return data;
	};

	return useMutation({
        mutationFn: mutate,
        onSuccess: onSuccess,
        onError: onFailure,
        onMutate: onMutate
	});
};